import { Card } from "@/src/components/shad/card";
import deposit from "@assets/money-recive.svg";
import withdraw from "@assets/money-send.svg";
import { Link } from "react-router-dom";
import { textVariants } from "@/src/components/Text/Text";
import { useTranslation } from "react-i18next";

const MiddleTabs = () => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-3">
      <Link to="/app/wallet/funding">
        <Card className="p-4 flex gap-2 items-center ">
          <div>
            <img src={deposit} alt="deposit" className="h-16 w-16" />
          </div>
          <div className="grid w-full">
            <span className={textVariants({ size: "lg" })}>
              {t("app.home.middle_tabs.deposit.title")}
            </span>
            <span className={textVariants({ size: "xs", variant: "desc" })}>
              {t("app.home.middle_tabs.deposit.desc")}
            </span>
          </div>
        </Card>
      </Link>
      <Link to="/app/wallet/funding/withdraw">
        <Card className="p-4 flex gap-2 items-center">
          <div>
            <img src={withdraw} alt="deposit" className="h-16 w-16" />
          </div>
          <div className="grid w-full">
            <span className={textVariants({ size: "lg" })}>
              {t("app.home.middle_tabs.withdraw.title")}
            </span>
            <span className={textVariants({ size: "xs", variant: "desc" })}>
              {t("app.home.middle_tabs.withdraw.desc")}
            </span>
          </div>
        </Card>
      </Link>
    </div>
  );
};

export default MiddleTabs;
